import React from 'react'
import clsx from 'clsx'
import { connect } from 'react-redux'
import Skeleton from '@mui/material/Skeleton'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { RootState } from 'duck'
import Typography from 'components/Typography'
import { apiSelectors } from 'duck/ApiDuck'
import { TextUtils } from 'utils/TextUtils'
import { License, LICENSE_TEXT } from 'appConstants'
import Tooltip from 'components/Tooltip'
import stylesGlobal from 'stylesGlobal.module.scss'
import styles from '../ProjectPage.module.scss'

const mapStateToProps = (state: RootState) => ({
  openedMineProject: apiSelectors.openedMineProject(state)
})

type ProjectSummaryProps = ReturnType<typeof mapStateToProps>

const ProjectSummary: React.FC<ProjectSummaryProps> = props => {
  const { openedMineProject } = props

  const license = openedMineProject?.license as License

  const licenseText = license ? LICENSE_TEXT[license] ?? '-' : '-'

  return (
    <div>
      <div className={stylesGlobal.MarginBottom32}>
        <Typography variant="body2" className={stylesGlobal.MarginBottom12} color="light">
          Description
        </Typography>

        {openedMineProject?.mine_limit ? (
          openedMineProject?.description.split('\n').map((text, index) => (
            <Typography key={index} variant="body1" variantXs="body2" paragraph>
              {text}
            </Typography>
          ))
        ) : (
          <Typography variant="body1" variantXs="body2" paragraph>
            <Skeleton width="50%" />
          </Typography>
        )}
      </div>

      {openedMineProject?.email || openedMineProject?.additional_benefit ? (
        <div>
          {/* If artist fills out the email field, then "Artist contact unlocked with purchase." appears.
                If anything else in the incentive box, put below it. */}
          <Typography variant="body2" color="light" className={stylesGlobal.MarginBottom16}>
            Additional Incentives
          </Typography>

          {openedMineProject?.email ? (
            <Typography variant="body1" variantXs="body2">
              Artist contact unlocked with purchase.
            </Typography>
          ) : null}

          {openedMineProject?.additional_benefit ? (
            <Typography variant="body1" variantXs="body2">
              {openedMineProject?.additional_benefit}
            </Typography>
          ) : null}
        </div>
      ) : null}

      <div className={clsx(stylesGlobal.MarginTop48, stylesGlobal.MarginBottom24)}>
        <Typography variant="body1" component="div" className={stylesGlobal.MarginBottom16}>
          <span
            className={clsx(
              stylesGlobal.DisplayInlineBlock,
              stylesGlobal.TextColorLight,
              styles.Width136
            )}
          >
            {`License: `}
          </span>
          <strong>{licenseText}</strong>
        </Typography>

        <Typography variant="body1" component="div" className={stylesGlobal.MarginBottom16}>
          <span
            className={clsx(
              stylesGlobal.DisplayInlineBlock,
              stylesGlobal.TextColorLight,
              styles.Width136
            )}
          >
            {`Blockchain: `}
          </span>
          <strong>{TextUtils.textTransform(openedMineProject?.network, 'titlecase')}</strong>
        </Typography>

        <Typography variant="body1" component="div" className={stylesGlobal.MarginBottom16}>
          <span
            className={clsx(
              stylesGlobal.DisplayInlineFlex,
              stylesGlobal.AlignItemsCenter,
              stylesGlobal.TextColorLight,
              styles.Width136
            )}
          >
            {`Royalty`}
            <Tooltip
              className={clsx(
                stylesGlobal.MarginLeft4,
                stylesGlobal.MarginRight4,
                stylesGlobal.TextColorLight,
                stylesGlobal.FontSize16
              )}
              title={'Secondary Sales Artist Royalty'}
            >
              <HelpOutlineIcon className={stylesGlobal.TextColorLight} fontSize="inherit" />
            </Tooltip>
            {':'}
          </span>

          <strong>{`10%`}</strong>
        </Typography>
      </div>
    </div>
  )
}

export default connect(mapStateToProps)(ProjectSummary)
